export default function MarketingSolutions() {
  const solutions = [
    {
      category: 'Digital Marketing',
      title: 'Digital Marketing Campaigns',
      description: 'Comprehensive digital marketing strategies including SEO, PPC, social media, and content marketing to drive qualified leads and brand awareness.',
      gradient: 'from-orange-400 to-pink-500',
      icon: 'ri-megaphone-line'
    },
    {
      category: 'Strategy',
      title: 'Market Entry Strategy',
      description: 'Detailed market analysis, competitive positioning, and strategic planning to ensure successful entry into new markets and territories.',
      gradient: 'from-teal-500 to-emerald-500',
      icon: 'ri-compass-3-line'
    },
    {
      category: 'Branding',
      title: 'Brand Positioning',
      description: 'Strategic brand development and positioning services that differentiate your technology solutions in competitive markets.',
      gradient: 'from-green-400 to-teal-500',
      icon: 'ri-award-line'
    }
  ];

  return (
    <section id="marketing" className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Marketing Solutions That Drive Results
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Our comprehensive marketing solutions are designed to accelerate your growth and establish your brand as a leader in your target markets.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {solutions.map((solution, index) => (
            <div
              key={index}
              className="bg-white rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 group cursor-pointer"
            >
              <div className={`h-64 bg-gradient-to-br ${solution.gradient} flex items-center justify-center relative overflow-hidden`}>
                <div className="absolute inset-0 bg-black/10"></div>
                <i className={`${solution.icon} text-8xl text-white/90 relative z-10 group-hover:scale-110 transition-transform duration-300`}></i>
              </div>
              <div className="p-8">
                <div className="inline-block px-4 py-1.5 bg-gray-100 rounded-full mb-4">
                  <span className="text-xs font-semibold text-gray-700 uppercase tracking-wider">
                    {solution.category}
                  </span>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">{solution.title}</h3>
                <p className="text-gray-600 leading-relaxed mb-6">{solution.description}</p>
                <div className={`w-12 h-12 rounded-full bg-gradient-to-br ${solution.gradient} flex items-center justify-center ml-auto cursor-pointer hover:scale-110 transition-transform`}>
                  <i className="ri-arrow-right-line text-white text-xl"></i>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
